/* eslint-env node, browser */
'use strict';

/**
 * resets all sequence counters except for the ones passed in
 *
 * @param {Object} doNotReset
 * @returns void
 */
module.exports = function (doNotReset) {
  var self = this;
  doNotReset = doNotReset || {};
  var activeSequences = false;
  var key;
  for (key in self.sequenceLevels) {
    if (doNotReset[key]) {
      activeSequences = true;
      continue;
    }
    self.sequenceLevels[key] = 0;
  }
  if (!activeSequences) {
    self.nextExpectedAction = false;
  }
};